import SchoolCommunicationSettings from './SchoolCommunicationSettings.page';

export default SchoolCommunicationSettings;
